import { MessageCircle, Sparkles, Footprints } from "lucide-react";
import { FadeIn } from "./motion/FadeIn";

const steps = [
  { icon: MessageCircle, title: "Vous me contactez", desc: "Un simple message sur WhatsApp suffit. Je vous réponds rapidement avec une réponse personnalisée." },
  { icon: Sparkles, title: "On construit votre expérience", desc: "On échange sur vos envies, votre rythme et votre façon de voyager. Je vous propose une expérience adaptée, pensée pour vous." },
  { icon: Footprints, title: "Vous profitez, je m'occupe du reste", desc: "Le jour J, je vous accompagne pour vous faire vivre Rio autrement. Vous n'avez plus qu'à profiter." },
];

export const HomeHowItWorks = () => (
  <section className="relative py-14 md:py-36 overflow-hidden">
    <div aria-hidden className="absolute -top-6 left-2 md:left-12 font-league text-[7rem] md:text-[20rem] leading-none text-roca-orange/[0.06] select-none pointer-events-none">
      04
    </div>
    <div className="absolute -top-32 right-0 w-[26rem] h-[26rem] rounded-full bg-primary/5 blur-3xl blob-float pointer-events-none" />
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative">
      <FadeIn className="mb-12 md:mb-16 max-w-2xl">
        <div className="flex items-center gap-3 mb-4">
          <span className="font-league text-xl text-roca-orange">04</span>
          <span className="h-px w-12 bg-roca-orange" />
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Le déroulé</p>
        </div>
        <h2 className="font-league uppercase text-3xl sm:text-5xl md:text-6xl text-foreground leading-[0.95]">
          Comment ça se passe ?
        </h2>
        <p className="mt-4 text-base sm:text-lg text-muted-foreground">
          3 étapes, simplement.
        </p>
      </FadeIn>

      <div className="relative grid md:grid-cols-3 gap-6 md:gap-6">
        {/* Connecting line (desktop) */}
        <div aria-hidden className="hidden md:block absolute top-12 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
        {steps.map((s, i) => (
          <FadeIn key={s.title} delay={i * 160} direction="up" distance={32}>
            <div className="relative h-full group p-5 sm:p-6 rounded-2xl card-lift bg-background/40">
              <div className="text-5xl sm:text-7xl font-league text-muted-foreground/15 leading-none mb-3 transition-all duration-500 group-hover:text-gradient-roca group-hover:translate-x-1">
                0{i + 1}
              </div>
              <s.icon className="w-6 h-6 sm:w-7 sm:h-7 text-roca-orange mb-3 sm:mb-4 transition-transform duration-500 group-hover:scale-125 group-hover:-rotate-12" />
              <h3 className="font-league uppercase text-xl sm:text-3xl text-foreground mb-3 leading-[0.95]">
                {s.title}
              </h3>
              <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default HomeHowItWorks;
